import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-itams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-itams.component.scss?ngResource";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationLocationItamsConstants } from "./create-application-location-itams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapTools } from "../../../../map/shared/map.tools";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { CreateApplicationUtils } from "../../../shared/utils/create-application-utils";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
export let CreateApplicationLocationItamsComponent = class CreateApplicationLocationItamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    mapTools;
    changeDetectorRefs;
    active;
    propertiesForm;
    descriptionLabel1 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationItamsConstants.DESCRIPTION_LABEL_3;
    validationMessages = CreateApplicationLocationItamsConstants.VALIDATION_MESSAGES;
    erfNoControl = CreateApplicationLocationItamsConstants.ERF_NO_CONTROL;
    propertiesFormGroupName = CreateApplicationLocationItamsConstants.PROPERTIES_FORM_GROUP_NAME;
    propertiesFormControlName = CreateApplicationLocationItamsConstants.PROPERTIES_FORM_CONTROL;
    subdivisionControl = CreateApplicationLocationItamsConstants.SUBDIVISION_CONTROL;
    allotmentControl = CreateApplicationLocationItamsConstants.ALLOTMENT_CONTROL;
    farmNoControl = CreateApplicationLocationItamsConstants.FARM_NO_CONTROL;
    sgCodeControl = CreateApplicationLocationItamsConstants.SG_CODE_CONTROL;
    addressControl = CreateApplicationLocationItamsConstants.ADDRESS_CONTROL;
    bayNumberControl = CreateApplicationLocationItamsConstants.BAY_NUMBER_CONTROL;
    baySizeControl = CreateApplicationLocationItamsConstants.BAY_SIZE_CONTROL;
    erfNoTextPlaceHolder = CreateApplicationLocationItamsConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = CreateApplicationLocationItamsConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = CreateApplicationLocationItamsConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = CreateApplicationLocationItamsConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = CreateApplicationLocationItamsConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = CreateApplicationLocationItamsConstants.ADDRESS_TEXT_PLACEHOLDER;
    bayNumberPlaceHolder = CreateApplicationLocationItamsConstants.BAY_NUMBER_PLACEHOLDER;
    erfSizeTextPlaceHolder = CreateApplicationLocationItamsConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    baySizeTextPlaceHolder = CreateApplicationLocationItamsConstants.BAY_SIZE_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeBayLabel = CreateApplicationLocationItamsConstants.REMOVE_BAY_LABEL;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    mapComponent;
    isMapLoaded = false;
    layerReference = CreateApplicationLocationItamsConstants.LAYER_REF;
    hasLoadedApplicationProperties = false;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, mapTools, changeDetectorRefs) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    getBays() {
        return this.propertiesForm.get(this.propertiesFormControlName);
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        this.subscribeToBayDetails();
        this.setupSubscribers();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionBayEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    ngOnDestroy() {
        this.mapService.actionBayEnabled = false;
        super.ngOnDestroy();
    }
    loadMetadata() {
    }
    onBtnRemoveSelectedBayClicked(propertyIndex) {
        this.getBays().removeAt(propertyIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getBays().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = false;
            this.farmNoControlRequired = false;
            this.erfNoControlRequired = true;
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = false;
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
            this.subdivisionControlRequired = true;
            this.farmNoControlRequired = true;
            this.erfNoControlRequired = true;
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get(this.propertiesFormGroupName);
    }
    syncMapGeometries() {
        const geometries = [];
        this.getBays().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, this.layerReference, true);
        }
    }
    setupSubscribers() {
        this.subscribeToClearGraphics();
        this.subscribeToSelectedApplication();
    }
    subscribeToClearGraphics() {
        this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getBays().clear();
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            this.selectedApplication = +this.jobId > 0 && application ? application : null;
            if (this.selectedApplication) {
                this.updateComponentData();
            }
        });
    }
    updateComponentData() {
        if (+this.jobId > 0 && this.selectedApplication) {
            const propertyControl = this.getBays();
            let tabIndex = 0;
            this.selectedApplication.properties.sort((a, b) => (b?.id - a?.id));
            this.selectedApplication.properties.forEach(savedProperty => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(savedProperty.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newPropertyFormGroup = this.getUpdatedBaysFormGroup(savedProperty, geom);
                this.propertiesForm.markAllAsTouched();
                this.applicationCreateService.getPropertyCentroidObservable(geom).subscribe({
                    next: (trueCentroidResponse) => {
                        CreateApplicationUtils.handleTrueCentroidResponse(trueCentroidResponse, newPropertyFormGroup);
                        propertyControl.push(newPropertyFormGroup);
                        this.active = propertyControl.length - 1;
                        this.updateRequiredFields(this.active);
                        this.syncMapGeometries();
                        CreateApplicationUtils.updatePropertyIds(this.selectedApplication, this.propertiesForm);
                        this.changeDetectorRefs.detectChanges();
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(CreateApplicationLocationItamsConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
                tabIndex++;
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.hasLoadedApplicationProperties = true;
            this.changeDetectorRefs.detectChanges();
        }
    }
    subscribeToBayDetails() {
        this.cleanupAfterDestroy(this.mapService.$selectedBay).subscribe(property => {
            if (property !== null) {
                this.setBayData(property.attributes, property.geometry);
            }
        });
    }
    setBayData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("SetBayData");
        const sgCode = CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgCode");
        const objectId = CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "OBJECTID", "objectId");
        let found = false;
        this.getBays().controls.forEach(item => {
            const check = item.get("objectId").value;
            if (check === objectId) {
                found = true;
                this.appController.showMessage(CreateApplicationLocationItamsConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("SetBayData");
            }
        });
        if (!found) {
            const newBay = new FormGroup({
                id: new FormControl(0),
                objectId: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "OBJECTID", "objectId")),
                erfNo: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfNumber"), [Validators.required]),
                subdivision: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "Subdivision", "ptnNum"), [Validators.required]),
                allotment: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmNumber"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                bayNumber: new FormControl(null, [Validators.required]),
                baySize: new FormControl(CreateApplicationUtils.propertyDataAlternateColumnName(propertyObject, "Size", "size"), [Validators.required]),
                centroid: new FormControl(null, [Validators.required])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.applicationCreateService.getTrueCentroid(url, formData)
                .subscribe((trueCentroidResponse) => {
                newBay.get("centroid").setValue(trueCentroidResponse.results[0].value);
                const propertyControl = this.getBays();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newBay);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            });
        }
    }
    getUpdatedBaysFormGroup(savedProperty, geom) {
        return new FormGroup({
            id: new FormControl(savedProperty.id),
            erfNo: new FormControl(savedProperty.erfNumber, [Validators.required]),
            subdivision: new FormControl(savedProperty.subdivision, [Validators.required]),
            allotment: new FormControl(savedProperty.allotment, [Validators.required]),
            property: new FormControl(savedProperty),
            farmNo: new FormControl(savedProperty.farmNumber, [Validators.required]),
            sgCode: new FormControl(savedProperty.sgCode, [Validators.required]),
            address: new FormControl(savedProperty.address, [Validators.required]),
            geometry: new FormControl(geom),
            bayNumber: new FormControl(savedProperty.bayNumber),
            baySize: new FormControl(savedProperty.baySize),
            centroid: new FormControl(null, [Validators.required])
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: MapTools },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationItamsComponent = __decorate([
    Component({
        selector: "app-create-application-location-itams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationLocationItamsComponent);
